import { render, staticRenderFns } from "./ModalInformative.vue?vue&type=template&id=aea1dc1c&"
import script from "./ModalInformative.vue?vue&type=script&lang=ts&"
export * from "./ModalInformative.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInformative.vue?vue&type=style&index=0&id=aea1dc1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports